<div>
  <ng-content select="button"></ng-content>
  <div class="absolute bottom-[76px] left-0 right-0 panel-background z-3">
    <div class="max-w-[1400px] mx-auto">
      <ng-container *tuiLet="records$ | async as records">
        @if ((collapsed$ | async) === false) {
          <div class="py-2 flex items-center">
            <div class="flex items-center">
              @for (button of buttons$ | async; track 'name') {
                <tui-badge
                  appearance="custom"
                  tuiTheme="dark"
                  class="mr-2 cursor-pointer"
                  [class]="'status-' + button.name"
                >
                  {{ button.title }}
                </tui-badge>
              }
              <button
                appearance="refresh-button"
                icon="tuiIconRotateCw"
                size="s"
                tuiIconButton
                (click)="refresh.emit()"
              ></button>
            </div>

            <div class="mr-0 ml-auto flex gap-x-2 items-center">
              <div class="w-[150px]">
                <tui-input tuiTextfieldSize="s" [formControl]="filter"
                  >Поиск</tui-input
                >
              </div>

              <ng-content select="action"></ng-content>
              <button
                appearance="info"
                size="s"
                tuiIconButton
                [icon]="
                  maximized$.value ? 'tuiIconMinimize' : 'tuiIconMaximize'
                "
                (click)="maximize()"
              ></button>
              <button
                appearance="accent"
                icon="tuiIconX"
                size="s"
                tuiIconButton
                (click)="closePanel()"
              ></button>
            </div>
          </div>
          @if (records?.length) {
            <div class="pb-2 text-base text-white">
              <div class="relative">
                <cdk-virtual-scroll-viewport
                  *tuiLet="filteredRecords$ | async as filtered"
                  tuiScrollable
                  class="cursor-pointer overscroll-none"
                  [itemSize]="50"
                  [maxBufferPx]="500"
                  [minBufferPx]="400"
                  [style.height.px]="virtualScrollHeight$ | async"
                >
                  <app-control-record
                    *cdkVirtualFor="let record of filtered; let index = index"
                    [errorAction]="errorAction"
                    [index]="index"
                    [record]="record"
                    (solved)="markAsSolved(record)"
                  ></app-control-record>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          } @else {
            <div class="h-[100px] flex items-center">
              <div
                class="p-3 mb-1 break-all bg-[var(--tui-text-positive)] w-full rounded-r-lg border-l-4 border-white text-white"
              >
                <tui-icon icon="tuiIconCheck"></tui-icon>
                Контроль успешно пройден
              </div>
            </div>
          }
        }
      </ng-container>
    </div>
  </div>
</div>
